import { Card as AntCard, Space, Typography, Row, Grid } from 'antd';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';
// import {
//   CLAIM_STATUSES,
//   getClaimAmountVisibility,
// } from "all-in-one-shared-api";
import { useTranslation } from 'react-i18next';
// import ClaimTypeIcon from 'components/claimTypeIcon';
// import { getClaimPageUrl } from 'utils';
// import { StyledTitle } from 'components/StyledTitle';
import TwoItemColumn from 'components/twoItemColumn';
import RegisterBadge from './RegisterBadge';
// import { ShortfallInfo } from './ShortfallInfo';
// import { PrimaryButton } from '../../../../components';
// import { useState, useEffect } from 'react';
import e14family from '../../../../assets/images/e14-family.svg';
import { changeDataFun } from 'utils';

const { Text } = Typography;

// const ClaimNumberText = styled(Text)`
//   color: var(--neutral-7);
// `;

const Card = styled(AntCard)`
  border-radius: 0.5rem;
  height: 100%;
`;
const Container = styled.div`
  width: 388px;

  @media (max-width: 768px) {
    width: 100%;
    paddingbottom: 20px;
  }
`;
const { useBreakpoint } = Grid;
// const SettleButton = styled(PrimaryButton)`
//   margin-top: 1em;
//   width: 100%;
// `;

// export const AlertsMessage = styled.div<{ alertsType: string }>`
//   background-color: ${(props) => (props.alertsType === 'Issued' ? '#F2FBE9' : '#fdeeec')};
//   padding: 20px;
//   width: 100%;
//   margin-bottom: 20px;
// `;
// const StyledCard = styled.div`
//   background-color: 'red';
//   padding: 16px;
//   border-radius: 16px;
//   height: auto;
//   min-height: 50px; /* 确保有最小高度 */
//   width: 100%; /* 设置宽度为100%以适应父容器 */
//   max-width: 300px; /* 可以设置一个最大宽度 */
//   display: flex;
//   justify-content: center;
//   align-items: center; /* 如果需要居中显示内容 */
// `;

export type LifeCardPropList = {
  color?: string;
  arrow?: true;
  stateCode?: string;
  policynumber?: string;
  title?: string;
  name?: string;
  policyTitle?: string;
  alertsType?: string;
  alertsCode?: string;
  dueDate?: string;
  productCategory?: string;
  productCategoryUrl?: string;
  productCategoryEn?: string;
  productCategoryTC?: string;
  companyCode?: string;
  productName?: string;
  productNameTc?: string;
  policyStatusCode?: string;
  policyStatus?: string;
  policyStatusEN?: string;
  policyStatusTC?: string;
  colour?: string;
  alertStateCode?: string;
  alertState?: string;
  alertStateTc?: string;
  policyNumber?: string;
  insuredName?: string;
  insuredNameTC?: string;
  premiumDueDate?: string;
  salesUnitCode?: string;
  memberId?: string;
  effectiveStart?: string;
  effectiveEnd?: string;
}[];
export interface LifeCardProps {
  data: LifeCardPropList;
  children?: React.ReactNode;
  isLife?: boolean;
}

const RegisterCard = (props: LifeCardProps) => {
  const { lg } = useBreakpoint();
  console.log(props.data, 'props.data=========');
  // const { t } = useTranslation();
  // const settleShortfallClicked = () => {
  //   onSettleShortfall &&
  //     onSettleShortfall(claimId || referenceNo || "", sequenceNo);
  // };
  const { t, i18n } = useTranslation();
  // const [svgContents, setSvgContents] = useState<string[]>([]);
  // useEffect(() => {
  //   const fetchSvgData = async () => {
  //     const svgData: string[] = await Promise.all(
  //       props?.data?.map(async (item) => {
  //         if (item.productCategoryUrl) {
  //           try {
  //             const response = await fetch(item.productCategoryUrl);
  //             return await response.text();
  //           } catch (error) {
  //             console.error('Error fetching SVG:', error);
  //             return ''; // 如果有错误，返回空字符串
  //           }
  //         }
  //         return ''; // 如果没有URL，返回空字符串
  //       }),
  //     );
  //     setSvgContents(svgData);
  //   };

  //   fetchSvgData();
  // }, [props.data]);

  return (
    <Row gutter={[{ xs: 8, sm: 16, md: 48 }, 24]} justify={lg ? 'center' : 'center'} wrap>
      {props?.data?.map((item, index) => {
        const {
          // stateCode,
          policyNumber,
          // title,
          insuredName,
          insuredNameTC,
          // policyTitle,
          productNameTc,
          productName,
          productCategoryEn,
          productCategoryTC,
          // alertsType,
          // alertsCode,
          premiumDueDate,
          color,
          colour,
          // arrow,
          // companyCode,
          policyStatus,
          policyStatusEN,
          policyStatusTC,
          // alertState,
          // alertStateTc,
          // alertStateCode,
          productCategoryUrl,
          memberId,
          effectiveStart,
          effectiveEnd,
        } = item;

        return (
          <TwoItemColumn key={index} style={{ minWidth: '388px' }}>
            <Container style={{ width: '100%' }}>
              <Card
                key={index}
                // title={<ClaimNumberText>{i18n.language == 'en' ? productCategoryEn : productCategoryTC}</ClaimNumberText>}
                bordered={true}
                style={{
                  padding: '8px',
                  maxWidth: '100%',
                  minWidth: '388px',
                  backgroundColor: 'white',
                  overflow: 'hidden',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // 添加阴影
                }}
              >
                {/* Basic info */}
                <Space align="start" style={{ width: '100%' }}>
                  {/* <ClaimTypeIcon claimType={'22222222222'} /> */}
                  {/* <MyIcon /> */}
                  <img src={props.isLife ? productCategoryUrl : e14family} alt="" width="32" height="32" />
                  {/* <iframe
                    src={props.isLife ? productCategoryUrl : e14family}
                    width="45"
                    height="45"
                    style={{ border: 'none' }}
                  /> */}
                  <Space direction="vertical" style={{ width: '100%', backgroundColor: 'white' }}>
                    {/* leave N/A in case claimTypeDescription is empty for the consistency of card's height*/}
                    <Text style={{ fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {props.isLife
                        ? i18n.language == 'en'
                          ? productCategoryEn
                          : productCategoryTC
                        : i18n.language == 'en'
                        ? 'Group Medical'
                        : '團體醫療'}
                    </Text>
                    {props.isLife && (
                      <Text
                        style={{
                          lineHeight: '33px',
                          fontSize: '33px',
                          fontFamily: 'Roboto400',
                          // whiteSpace: 'nowrap', // 禁止换行
                          overflow: 'hidden', // 超过宽度隐藏
                          textOverflow: 'ellipsis', // 超出文本部分显示省略号
                          width: '100%', // 可根据需求设置最大宽度
                          display: 'inline-block', // 设置为块级元素，确保宽度受控
                        }}
                      >
                        {i18n.language == 'en' ? productName : productNameTc}
                      </Text>
                    )}
                    {/* <StyledTitle level={5}>{i18n.language == 'en' ? policyStatus : policyStatusTc}</StyledTitle> */}
                    {!props.isLife && (
                      <RegisterBadge
                        color={color ?? '#7ED321'}
                        // status={i18n.language == 'en' ? policyStatusEN ?? '' : policyStatusTc ?? ''}
                        status={policyStatus ? (i18n.language == 'en' ? 'ACTIVE' : '生效') : ''}
                      />
                    )}
                    {props.isLife && (
                      <RegisterBadge
                        color={color || colour || '#7ED321'}
                        status={i18n.language == 'en' ? policyStatusEN || '' : policyStatusTC || ''}
                      />
                    )}
                    {/* <StyledCard
                  style={{
                    marginBottom: 10,
                    alignSelf: 'flex-start',
                    backgroundColor:
                      color == 'GREEN'
                        ? '#7ED321'
                        : color == 'RED'
                        ? '#F1644A'
                        : color == 'GREY'
                        ? '#D9D9D9'
                        : '#7ED321',
                  }}
                >
                  <Text>{i18n.language == 'en' ? policyStatus : policyStatusTc}</Text>
                </StyledCard> */}

                    {/* {alertsType && (
                  <AlertsMessage alertsType={alertsCode || ''}>
                    <Text
                    // color={alertsCode == 'Issued' ? '#549736' : '#C21B17'}
                    // numberOfLines={1}
                    // ellipsizeMode="tail"
                    >
                      {i18n.language == 'en' ? alertState : alertStateTc}
                    </Text>
                  </AlertsMessage>
                )} */}

                    <Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }} type="secondary">
                      {t('registration.policyNumber', {
                        policyNumber: policyNumber,
                      })}
                    </Text>
                    {!props.isLife && (
                      <Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }} type="secondary">
                        {t('registration.memberId', { memberId: memberId })}
                      </Text>
                    )}
                    {props.isLife && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          width: '300px',
                          justifyContent: 'flex-start',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            marginRight: '5px',
                          }}
                        >
                          <Text
                            type="secondary"
                            style={{ fontSize: '17px', fontFamily: 'Roboto400', whiteSpace: 'nowrap' }}
                          >
                            {t('registration.insuredname')}
                          </Text>
                        </div>
                        <div style={{ overflow: 'hidden' }}>
                          <Text style={{ fontSize: '17px', overflow: 'hidden' }} type="secondary">
                            {t('registration.insuredname2', {
                              insuredName: i18n.language == 'en' ? insuredName : insuredNameTC,
                            })}
                          </Text>
                        </div>
                      </div>
                    )}
                    {props.isLife && premiumDueDate && (
                      <Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }} type="secondary">
                        {t('registration.dueDate', {
                          dueDate: i18n.language == 'en' ? premiumDueDate : changeDataFun(premiumDueDate),
                        })}
                      </Text>
                    )}
                    {!props.isLife && (
                      <Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }} type="secondary">
                        {t('registration.latestEffectivePeriod', {
                          latestEffectivePeriod1:
                            i18n.language == 'en' ? effectiveStart : changeDataFun(effectiveStart || ''),
                          latestEffectivePeriod2:
                            i18n.language == 'en' ? effectiveEnd : changeDataFun(effectiveEnd || ''),
                        })}
                      </Text>
                    )}
                  </Space>
                </Space>

                {/* Shortfall info */}

                {/* <Divider type="horizontal" /> */}
                {/* <ShortfallInfo
            label={t("claims.shortfall.RegisterCard.patientName")}
            // value={patientName || ""}
          /> */}
                {/* <ShortfallInfo
            label={t("claims.shortfall.RegisterCard.shortfallAmount")}
            value={
              osShortfallAmount
                ? `${osShortfallAmount.currency} ${osShortfallAmount.amount}`
                : ""
            }
            isValueRed
          />
        */}
                {/* <ShortfallInfo
              label={t("claims.shortfall.RegisterCard.daysOverdue")}
              value={`${daysOverdue}`}
              isValueRed={!!daysOverdue}
            /> */}

                {/* <SettleButton
            color="var(--primary-color)"
            onClick={settleShortfallClicked}
          >
            {t("claims.shortfall.settleShortfall")}
          </SettleButton>
        */}
              </Card>
            </Container>
          </TwoItemColumn>
        );
      })}
    </Row>
  );
};

export default RegisterCard;
